import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip, Chip, Box } from "@mui/material";
import { fDateTime, yearFirstDateTimeFormat } from "src/utils/formatTime";
import { CustomerActionMenu } from "./CustomerActionMenu";
import CustomerTagActionMenu from "./CustomerTagActionMenu";

const dateFormat = "yyyy-MM-dd hh:mm a";

export const userListColumns = (isReadOnly) => [
  {
    field: "fullName",
    headerName: "Name",
    width: 150,
    valueGetter: (params) =>
      `${params?.row?.firstName ? params?.row?.firstName : ""} ${
        params?.row?.lastName ? params?.row?.lastName : ""
      }`,
  },
  {
    field: "email",
    headerName: "Email ID",
    flex: 1,
    minWidth: 200,
    renderCell: ({ value, id }) => (
      <>
        {isReadOnly ? (
          value
        ) : (
          <Link underline="none" component={RouterLink} to={`${id}`}>
            {value}
          </Link>
        )}
      </>
    ),
  },
  {
    field: "phone",
    headerName: "Phone Number",
    width: 130,
  },
  {
    field: "domain",
    headerName: "Domain",
    width: 120,
  },
  {
    field: "balanceAmount",
    headerName: "Wallet Balance",
    width: 120,
  },
  {
    field: "active",
    headerName: "Status",
    width: 120,
    renderCell: ({ value }) => {
      const isActive = value === "Y";
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Chip
            label={isActive ? "Active" : "Inactive"}
            color={isActive ? "success" : "error"}
            variant={isActive ? "filled" : "outlined"}
            size="small"
            sx={{
              fontWeight: 600,
              fontSize: '0.75rem',
              minWidth: 70,
            }}
          />
        </Box>
      );
    },
  },
  {
    field: "createdAt",
    headerName: "Created on",
    type: "date",
    width: 180,
    valueFormatter: ({ value }) => {
      return fDateTime(value, dateFormat);
    },
  },
  {
    field: "Actions",
    width: 50,
    sortable: false,
    headerName: "",
    renderCell: ({ id, row }) => {
      return <CustomerActionMenu id={id} row={row} />;
    },
  },
];

export const getCustomerDefaultValues = (teamId) => ({
  companyId: teamId,
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  locationLatitude: "",
  locationLongitude: "",
  street: "",
  house_number: "",
  zipCode: "",
  state: "",
  country: "",
  domain: "",
  // ocppTagId: ""
});

export const customerFormTabs = [
  { value: "general", label: "GENERAL" },
  { value: "address", label: "ADDRESS" },
  { value: "tags", label: "RFID TAGS" },
];

export const hideForTabs = ["tags"];

export const customerTagFormColumns = (refetch, removeTagFn) => [
  {
    field: "tag",
    headerName: "RFID Tag",
    flex: 1,
    renderCell: ({ value, row: { ocpp_tag_pk } }) => {
      return (
        <Link
          underline="none"
          component={RouterLink}
          to={`/tag/${ocpp_tag_pk}`}
        >
          {value}
        </Link>
      );
    },
  },
  {
    field: "parenttag",
    headerName: "Parent Group",
    flex: 1,
  },
  {
    field: "expirydate",
    headerName: "Expiry Date/Time",
    flex: 1,
    renderCell: ({ value }) => (
      <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
        <span>{yearFirstDateTimeFormat(value)}</span>
      </Tooltip>
    ),
  },
  {
    field: "in_transaction",
    headerName: "In Transactions",
    type: "boolean",
    flex: 1,
  },
  {
    field: "blocked",
    headerName: "Blocked",
    type: "boolean",
    flex: 1,
  },
  {
    field: "Actions",
    width: 50,
    sortable: false,
    headerName: "",
    renderCell: ({ id, row }) => {
      return (
        <CustomerTagActionMenu
          id={id}
          row={row}
          refetch={refetch}
          removeTagFn={removeTagFn}
        />
      );
    },
  },
];
